import {z} from '@hono/zod-openapi';

/**
 * A stored price report request: the 13 fields the legacy `PRR_request_response` type declares
 * plus `featuresLevel`, in the order the module's `REQUEST_DETAIL_KEYS` lists them. A NULL column
 * or a field the stored blob does not carry is absent; `POST /request` answers the subset its
 * body set. Nullable because the legacy operations answer a bare `null` when there is nothing to
 * return, and that four-byte body is kept.
 *
 * The row columns are typed. The blob fields come from stored legacy JSON and stay open.
 */
export const priceReportRequestResponseSchema = z
  .object({
    id: z.string().optional(),
    idPriceReport: z.string().optional(),
    created: z.string().optional(),
    market: z.unknown(),
    currency: z.unknown(),
    vehicle: z.unknown(),
    additionalSettings: z.unknown(),
    /** `null` only on `POST /request`, which echoes the cast of a body value that is no string. */
    customerId: z.string().nullable().optional(),
    vehicleId: z.string().nullable().optional(),
    couponNumber: z.unknown(),
    serviceCode: z.string().optional(),
    vinDecoded: z.unknown(),
    vinDecodedPaid: z.unknown(),
    featuresLevel: z.unknown(),
  })
  .nullable()
  .openapi('PriceReportRequestResponse');
